export const ucFirst = txt => {
  return txt.charAt(0).toUpperCase() + txt.slice(1)
}